import badmintonData from "../../data/badmintonData";
import ServiceHero from "../../components/ServiceHero/ServiceHero";
import ServiceOverview from "../../components/ServiceOverview/ServiceOverview";
import ServiceBenefits from "../../components/ServiceBenefits/ServiceBenefits";
import ConstructionProcess from "../../components/ConstructionProcess/ConstructionProcess";
import TechnicalSpecs from "../../components/TechnicalSpecs/TechnicalSpecs";
import ServiceGallery from "../../components/ServiceGallery/ServiceGallery";
import WhyChooseService from "../../components/WhyChooseService/WhyChooseService";
import ServiceFAQ from "../../components/ServiceFAQ/ServiceFAQ";
import RelatedServices from "../../components/RelatedServices/RelatedServices";
import ServiceCTA from "../../components/ServiceCTA/ServiceCTA";

const BadmintonCourt = () => {
  return (
    <>
      <ServiceHero data={badmintonData} />

      <ServiceOverview data={badmintonData} />

      <ServiceBenefits data={badmintonData} />

      <ConstructionProcess />

      <TechnicalSpecs data={badmintonData} />

      <ServiceGallery data={badmintonData} />

      <WhyChooseService data={badmintonData} />

      <ServiceFAQ faqs={badmintonData.faqs} />

      <RelatedServices data={badmintonData} />

      <ServiceCTA data={badmintonData} />
    </>
  );
};

export default BadmintonCourt;
